import React from 'react';
import { Badge, BadgeProps } from 'react-bootstrap';
import { tInsurancePolicyStatus, getInsurancePolicyStatusVariant, InsurancePolicyStatuses } from '@models/InsurancePolicy';

type Props = BadgeProps & {
  status: InsurancePolicyStatuses;
};

const InsurancePolicyBadge = ({ status, ...rest }: Props) => {
  const variant = getInsurancePolicyStatusVariant(status);

  return (
    <Badge {...rest} bg={variant}>
      {tInsurancePolicyStatus(status)}
    </Badge>
  );
};

export { InsurancePolicyBadge };
